import type { MessageKey } from './en';

/** Spanish messages (es-419 register). Must define exactly the keys of en.ts. */
export const es: Record<MessageKey, string> = {
  "app.title": "Cuenta Spoonity",
  "app.skipToContent": "Ir al contenido",
  "lang.toggle": "English",
  "lang.label": "Idioma",
  "login.heading": "Inicia sesión en tu cuenta",
  "login.intro": "Ingresa el correo donde recibes las facturas de Spoonity.",
  "login.emailLabel": "Correo electrónico",
  "login.submit": "Enviar código",
  "login.invalidEmail": "Ingresa un correo válido.",
  "login.haveCode": "Ya tengo un código",
  "login.cooldown": "No se puede enviar otro código durante {seconds} s. Si ya recibiste uno, usa 'Ya tengo un código' más abajo.",
  "code.heading": "Revisa tu correo",
  "code.intro": "Si {email} está registrado en una cuenta Spoonity, te enviamos un código de 6 dígitos. Vence en 10 minutos.",
  "code.introNoEmail": "Ingresa el código de 6 dígitos del correo que te enviamos. Vence 10 minutos después de enviarse.",
  "code.label": "Código de 6 dígitos",
  "code.submit": "Iniciar sesión",
  "code.resend": "Enviar un código nuevo",
  "code.resendIn": "Puedes pedir un código nuevo en {seconds} s",
  "code.resent": "Te enviamos un código nuevo.",
  "code.changeEmail": "Usar otro correo",
  "code.needNewCode": "Necesito un código nuevo",
  "code.invalid": "El código no es correcto. Te quedan {n} intentos.",
  "code.expired": "Este código venció. Pide uno nuevo.",
  "code.tooMany": "Demasiados intentos. Pide un código nuevo o inténtalo más tarde.",
  "code.format": "Ingresa los 6 dígitos del correo.",
  "code.noEmail": "¿No te llegó? Revisa el correo no deseado o pide a tu contacto en Spoonity que confirme tu correo de facturación.",
  "picker.heading": "Elige una cuenta",
  "picker.intro": "Tu correo tiene acceso a estas cuentas.",
  "picker.balance": "Saldo {amount}",
  "picker.overdue": "{amount} vencido",
  "nav.overview": "Resumen",
  "nav.invoices": "Facturas",
  "nav.payments": "Pagos",
  "nav.statement": "Estado de cuenta",
  "nav.switchAccount": "Cambiar de cuenta",
  "nav.signOut": "Cerrar sesión",
  "nav.signOutAll": "Cerrar sesión en todos los dispositivos",
  "nav.signedInAs": "Sesión iniciada como {email}",
  "nav.sections": "Secciones de la cuenta",
  "overview.balance": "Saldo pendiente",
  "overview.overdue": "Vencido",
  "overview.credits": "Créditos disponibles",
  "overview.nextDue": "Próximo vencimiento",
  "overview.nextDueValue": "Factura {number}, {amount}, vence el {date}",
  "overview.nothingDue": "No tienes pagos pendientes. ¡Gracias!",
  "overview.aging": "Saldo abierto por antigüedad",
  "overview.recentInvoices": "Facturas recientes",
  "overview.recentPayments": "Pagos recientes",
  "overview.viewAll": "Ver todo",
  "aging.current": "Por vencer",
  "aging.1-30": "1 a 30 días",
  "aging.31-60": "31 a 60 días",
  "aging.61-90": "61 a 90 días",
  "aging.90+": "Más de 90 días",
  "common.dataAsOf": "Actualizado {time}",
  "common.loading": "Cargando",
  "common.retry": "Reintentar",
  "common.back": "Volver",
  "common.download": "Descargar PDF",
  "common.print": "Imprimir",
  "invoices.heading": "Facturas",
  "invoices.tab.open": "Pendientes",
  "invoices.tab.paid": "Pagadas",
  "invoices.tab.all": "Todas",
  "invoices.search": "Buscar por número de factura",
  "invoices.from": "Desde",
  "invoices.to": "Hasta",
  "invoices.col.number": "Factura",
  "invoices.col.date": "Fecha",
  "invoices.col.due": "Vence",
  "invoices.col.total": "Total",
  "invoices.col.balance": "Saldo",
  "invoices.col.status": "Estado",
  "invoices.loadMore": "Ver más",
  "status.open": "Pendiente",
  "status.overdue": "Vencida hace {days} días",
  "status.paid": "Pagada",
  "status.partial": "Pago parcial",
  "invoice.heading": "Factura {number}",
  "invoice.date": "Fecha de factura",
  "invoice.due": "Fecha de vencimiento",
  "invoice.terms": "Condiciones",
  "invoice.billTo": "Facturar a",
  "invoice.memo": "Nota",
  "invoice.lines": "Conceptos",
  "invoice.col.description": "Descripción",
  "invoice.col.qty": "Cant.",
  "invoice.col.rate": "Precio",
  "invoice.col.amount": "Importe",
  "invoice.subtotal": "Subtotal",
  "invoice.tax": "Impuestos",
  "invoice.total": "Total",
  "invoice.paid": "Pagado",
  "invoice.balance": "Saldo a pagar",
  "invoice.payments": "Pagos aplicados",
  "invoice.payNow": "Pagar ahora",
  "invoice.payNowNote": "Abre la página de pago segura de Spoonity con Stripe.",
  "invoice.stripeManaged": "Esta factura se paga con Stripe. Usa el enlace del correo de Stripe o la tarjeta registrada.",
  "invoice.contactToPay": "Para pagar esta factura, contacta a tu contacto de facturación de Spoonity.",
  "invoice.pdfPending": "El PDF aún no está disponible. Inténtalo más tarde.",
  "payments.heading": "Pagos",
  "payments.col.date": "Fecha",
  "payments.col.amount": "Importe",
  "payments.col.reference": "Referencia",
  "payments.col.applied": "Aplicado a",
  "payments.unapplied": "Sin aplicar {amount}",
  "statement.heading": "Estado de cuenta",
  "statement.period": "Período",
  "statement.preset.thisMonth": "Este mes",
  "statement.preset.lastMonth": "Mes anterior",
  "statement.preset.last3": "Últimos 3 meses",
  "statement.preset.ytd": "En lo que va del año",
  "statement.preset.custom": "Personalizado",
  "statement.opening": "Saldo inicial",
  "statement.closing": "Saldo final",
  "statement.charges": "Facturas",
  "statement.credits": "Pagos y créditos",
  "statement.col.date": "Fecha",
  "statement.col.type": "Tipo",
  "statement.col.reference": "Referencia",
  "statement.col.charge": "Cargo",
  "statement.col.credit": "Abono",
  "statement.col.balance": "Saldo",
  "statement.kind.invoice": "Factura",
  "statement.kind.payment": "Pago",
  "statement.kind.credit": "Nota de crédito",
  "statement.unreliable": "Los saldos inicial y final no están disponibles en línea para esta cuenta. Contáctanos para obtener un estado de cuenta completo.",
  "statement.historyLimit": "Los estados de cuenta están disponibles desde {date}.",
  "statement.invalidPeriod": "Elige una fecha inicial anterior o igual a la final.",
  "statement.apply": "Aplicar",
  "empty.invoicesOpen": "No hay facturas pendientes.",
  "empty.invoicesPaid": "No hay facturas pagadas en este período.",
  "empty.invoices": "No hay facturas en este período.",
  "empty.payments": "No hay pagos en este período.",
  "empty.statement": "No hay movimientos en este período.",
  "signedOut.heading": "Cerraste sesión",
  "signedOut.again": "Iniciar sesión de nuevo",
  "expired.heading": "Tu sesión terminó",
  "expired.body": "Por tu seguridad, cerramos la sesión después de 30 minutos sin actividad.",
  "unavailable.heading": "El portal de cuentas no está disponible por el momento",
  "unavailable.body": "Inténtalo más tarde.",
  "error.rateLimited": "Demasiadas solicitudes. Inténtalo en {seconds} s.",
  "error.generic": "Algo salió mal. Inténtalo de nuevo.",
  "error.network": "Parece que no tienes conexión. Revísala.",
  "error.notFound": "No encontramos esa página.",
  "footer.help": "¿Preguntas sobre tu cuenta? Contacta a tu contacto de facturación de Spoonity.",
  "footer.privacy": "Privacidad",
  "testAccount.title": "CUENTA DE PRUEBA",
  "testAccount.body": "Datos de ejemplo para verificar el portal. No es una cuenta de cliente real y no se debe nada.",
};
